import { lazy } from 'react';

const RecoveringPasswordCode = lazy(() =>
  import(
    /* webpackChunkName: "RecoveringPasswordCode" */ '@common2/Authorization/RecoveringPassword/RecoveringPasswordCode'
  )
);

export default RecoveringPasswordCode;
